import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { PaymentTransportationMethod } from 'src/app/shared';
import { PaymentService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class TransportationResolver
  
{
  constructor(private paymentService: PaymentService) {}
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<PaymentTransportationMethod[]> {
    return this.paymentService.getTransportationMethods();
  }
}
